module.exports = __webpack_public_path__ + "img/12.987b6265.png";